import {
  Text,
  ReactTable,
  Box,
  IconButton,
  Icon,
  Flex,
} from '@wegroup/design-system';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Cell } from 'react-table';
import { NaceCode } from '../../../../types/CompanyScanTypes';
import TableFiller from '../common/TableFiller';

interface Props {
  naceCodes: NaceCode[];
  onRemove: (index: number) => void;
  isDisabled?: boolean;
}

const NaceCodeTable: React.FC<React.PropsWithChildren<Props>> = ({
  naceCodes,
  onRemove,
  isDisabled,
}) => {
  const { t } = useTranslation();

  const renderCodeCell = (cell: Cell) => {
    const { code } = cell?.row?.original as NaceCode;

    return <Text>{code}</Text>;
  };

  const renderDescriptionCell = (cell: Cell) => {
    const { label } = cell?.row?.original as NaceCode;

    return <Text color="text.gray">{label}</Text>;
  };

  const renderActionMenuCell = (cell: Cell) => {
    const index = cell?.row?.index;

    return (
      <Flex justify="flex-end">
        <IconButton
          variant="dangerSecondary"
          icon={<Icon name="GeneralActionsThrash" />}
          onClick={() => onRemove(index)}
          aria-label="remove"
          isDisabled={isDisabled}
        />
      </Flex>
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: t('CODE'),
        accessor: 'type',
        Cell: renderCodeCell,
        isSticky: true,
      },
      {
        Header: t('DESCRIPTION'),
        accessor: 'duration',
        Cell: renderDescriptionCell,
      },
      {
        Header: t('ACTIONS'),
        id: 'actions',
        Cell: renderActionMenuCell,
        disableSortBy: true,
      },
    ],
    [naceCodes],
  );

  return (
    <Box>
      <ReactTable
        data={naceCodes}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        columns={columns as any}
      />
      {naceCodes.length === 0 && (
        <TableFiller>
          <Text>{t('FLOWS_COMPANY-SCAN_NACE-INPUT_EMPTY-TABLE')}</Text>
        </TableFiller>
      )}
    </Box>
  );
};

export default NaceCodeTable;
